import React, { useCallback, useEffect, useState } from 'react';
import api from '../../../services/api';
import { toast } from 'sonner';
import { Loader2, ScrollText, History } from 'lucide-react';
import { fmtDate, gbErr, AUDIT_LABEL } from './gbAdminUtils';

const describe = (a) => {
  const d = a.data || {};
  if (a.action === 'diamonds_adjusted') return `KAKO ${d.kako_id} · ${d.diamonds >= 0 ? '+' : ''}${d.diamonds} 💎 · ${d.reason || ''}`;
  if (a.action === 'player_blocked' || a.action === 'player_unblocked') return `KAKO ${d.kako_id} · ${d.reason || ''}`;
  if (a.action === 'suspicion_cleared') return `KAKO ${d.kako_id} · ${d.reason || ''}`;
  if (a.action === 'config_changed') return d.reason || 'sem motivo informado';
  return Object.keys(d).length ? JSON.stringify(d) : '';
};

export default function GbAudit({ seasonId }) {
  const [audit, setAudit] = useState([]);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [a, h] = await Promise.all([
        api.get(`/admin/gb/season/${seasonId}/audit`, { params: { limit: 200 } }),
        api.get(`/admin/gb/season/${seasonId}/config-history`),
      ]);
      setAudit(a.data.audit || []);
      setHistory(h.data.history || []);
    } catch (e) { toast.error(gbErr(e)); } finally { setLoading(false); }
  }, [seasonId]);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="flex justify-center p-6"><Loader2 className="h-5 w-5 animate-spin text-slate-400" /></div>;

  return (
    <div className="grid gap-4 md:grid-cols-2" data-testid="gb-admin-audit">
      <div className="space-y-2">
        <p className="flex items-center gap-1.5 text-xs font-black uppercase text-slate-500">
          <ScrollText className="h-3.5 w-3.5" /> Tudo que o admin fez · {audit.length}
        </p>
        <div className="max-h-[520px] space-y-1 overflow-y-auto rounded-xl border p-2">
          {audit.length === 0 && <p className="p-2 text-xs text-slate-400">Nada registrado ainda.</p>}
          {audit.map((a, i) => (
            <div key={i} className="rounded-lg border-b px-2 py-1.5 last:border-0" data-testid={`gb-audit-${i}`}>
              <p className="text-xs font-bold text-slate-700">{AUDIT_LABEL[a.action] || a.action}</p>
              <p className="text-[11px] text-slate-500">{describe(a)}</p>
              <p className="text-[10px] text-slate-400">{fmtDate(a.created_at)}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-2">
        <p className="flex items-center gap-1.5 text-xs font-black uppercase text-slate-500">
          <History className="h-3.5 w-3.5" /> Histórico de configuração · {history.length}
        </p>
        <div className="max-h-[520px] space-y-1 overflow-y-auto rounded-xl border p-2">
          {history.length === 0 && <p className="p-2 text-xs text-slate-400">Nenhuma alteração de números até agora.</p>}
          {history.map((h, i) => (
            <div key={i} className="border-b px-2 py-1.5 last:border-0" data-testid={`gb-config-history-${i}`}>
              <p className="text-xs font-bold text-slate-700">{h.reason || 'sem motivo informado'}</p>
              <pre className="mt-1 overflow-x-auto rounded bg-slate-50 p-1.5 text-[10px] text-slate-600">
                {JSON.stringify(h.changed, null, 1)}
              </pre>
              <p className="text-[10px] text-slate-400">{fmtDate(h.created_at)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
